export const SELECT_COLUMN_WIDTH = 35;
export const RESPONSIVE_COLUMN_WIDTH = 30;
export const EXPANDED_COLUMN_WIDTH = 30;
